// @TODO o que faz essa ffunção?

const articlesResize = () => {
  const newsItem = $('.news-internal .news-item');
  const newsItemThumb = $('.news-internal .news-item__thumb');
  const newsItemTitle = $('.news-internal .news-item__title');
  const newsDescription = $('.news-internal .news-item__description');

  $(window).resize(() => {
    const windowWidth = window.innerWidth;

    if (windowWidth < 500) {
      newsItem.addClass('news-item--news');
      newsItemThumb.addClass('news-item__thumb--news');
      newsItemTitle.addClass('news-item__title--news');
      newsDescription.addClass('news-item__description--news');
    } else {
      newsItem.removeClass('news-item--news');
      newsItemThumb.removeClass('news-item__thumb--news');
      newsItemTitle.removeClass('news-item__title--news');
      newsDescription.removeClass('news-item__description--news');
    }
  }).resize();
};

export default articlesResize;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/articles/articlesResize.js